import { Navigate } from 'react-router-dom';
import Dashboard from './layouts/Dashboard';
import Main from './layouts/Main';
import Page404 from './pages/404';
import DashboardPage from './pages/DashboardPage';
import ForgotPassword from './pages/ForgotPassword';
import InviteAccept from './pages/InviteAccept';
import Journals from './pages/Journals';
import Login from './pages/Login';
import MyBoxes from './pages/MyBoxes';
import CoachesPage from './pages/Organisation/CoachesPage';
import EmployeesPage from './pages/Organisation/EmployeesPage';
import MyOrganisation from './pages/Organisation/MyOrganisation';
import UsersAccessPage from './pages/Organisation/UsersAccessPage';
import UsersPage from './pages/Organisation/UsersPage';
import Profile from './pages/Profile';
import Reminders from './pages/Reminders';
import ResetPassword from './pages/ResetPassword';
import Resources from './pages/Resources';
import SharedJournal from './pages/SharedJournal';
import Signup from './pages/Signup';
import FourBoxesPage from './pages/Templates/FourBoxesPage';
import JournalTemplates from './pages/Templates/Journal';
import Vaults from './pages/Vaults';
import Logout from './utils/logout';
import Help from './pages/Help';
import NotificationsPage from './pages/Notifications';
const routes = ({ isAuth, userInfo, isAssumed, assumedUserInfo }) => [
  {
    path: '/',
    element: isAuth ? <Navigate to="/dashboard" /> : <Main />,
    children: [
      {
        path: '/',
        element: <Login />,
      },
      { path: 'signup', element: <Signup /> },
      { path: 'forgot-password', element: <ForgotPassword /> },
      { path: 'password_reset', element: <ResetPassword /> },
      { path: '404', element: <Page404 /> },
      { path: '*', element: <Navigate to="/404" replace={true} /> },
    ],
  },
  {
    path: 'shared_journal',
    element: <Main />,
    children: [
      { path: ':reference', element: <SharedJournal /> },
      { path: '404', element: <Page404 /> },
    ],
  },
  {
    path: 'invitation',
    element: <Main />,
    children: [
      { path: 'accept', element: <InviteAccept /> },
      { path: '404', element: <Page404 /> },
    ],
  },
  {
    path: 'user/auth',
    element: <Logout />,
  },
  {
    path: 'dashboard',
    element: isAuth ? <Dashboard /> : <Navigate to="/" />,
    children: [
      {
        path: '/dashboard',
        element: <DashboardPage />,
      },
      {
        path: 'notifications',
        element: <NotificationsPage />,
      },
      {
        path: 'my-4boxes',
        element: <MyBoxes />,
      },
      {
        path: 'resources',
        element: <Resources />,
      },
      {
        path: 'profile',
        element: <Profile />,
      },
      {
        path: 'vault',
        element: isAssumed ? <Navigate to="/" /> : <Vaults />,
      },
      {
        path: 'journal',
        element: isAssumed ? <Navigate to="/" /> : <Journals />,
      },
      {
        path: 'reminders',
        element: isAssumed ? <Navigate to="/" /> : <Reminders />,
      },
      {
        path: 'settings/templates/journal',
        element: isAssumed ? <Navigate to="/" /> : <JournalTemplates />,
      },
      {
        path: 'settings/templates/4boxes',
        element:
          isAssumed ||
          (userInfo?.role !== 'coach' && userInfo?.role !== 'admin') ? (
            <Navigate to="/" />
          ) : (
            <FourBoxesPage />
          ),
      },
      {
        path: 'settings/organisation',
        element: <MyOrganisation />,
      },
      {
        path: 'settings/organisation/employees',
        element: isAssumed ? <Navigate to="/" /> : <EmployeesPage />,
      },
      {
        path: 'settings/organisation/coaches',
        element: isAssumed ? <Navigate to="/" /> : <CoachesPage />,
      },
      {
        path: 'settings/organisation/user-access',
        element: isAssumed ? <Navigate to="/" /> : <UsersAccessPage />,
      },
      {
        path: 'settings/organisations',
        element: <UsersPage />,
      },
      {
        path: 'help',
        element: <Help />,
      },
      { path: 'tasks', element: '<DashboardTasks />' },
      { path: '*', element: '<Navigate to="/404" />' },
    ],
  },
  { path: '*', element: <Page404 /> },
];

export default routes;
